import {initWebComponent} from "@/helpers/web-component-helper";
import {loadInfoCharacteristics} from "@/helpers/layer/info/layer-info-characteristics-helper";
import {removeAllActiveClasses} from "@/helpers/layer-menu-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {getBookmarkPresentationsByID} from "@/helpers/ol/ol-layer-helper";
import {getKVLayerByBookmarkPresentationID} from "@/helpers/kv/kv-layer-helper";
import {setViewResolution} from "@/helpers/ol/view/ol-view-resolutation-helper";

export class LayerMenuButtonZoomScaleComponent extends HTMLElement{
    constructor(){
        super();

        let label = ''
        if(this.closest('layer-menu-group-item')) {
            label = this.closest('layer-menu-group-item').dataset.label
        }

        if(label === ''){
            label = this.getAttribute('data-label')
        }

        const className = this.getAttribute('data-class-name')

        const template = document.createElement('template');

        template.innerHTML = `<button title="Zoom naar zichtbare schaal van: ${label}" class="btn btn-sm borderless icon-btn text-transform-none btn-characteristics ${className}">
              <i class="fa fa-eye-slash"></i>
            </button>`

        initWebComponent(this, template)

        const id = this.getAttribute('data-id')

        this.addEventListener('click', () => {
            zoomToScale(id)
        });
    }
}

function zoomToScale(bookmarkPresentationID) {
    const bookmarkPresentation = getKVLayerByBookmarkPresentationID(bookmarkPresentationID)
    setViewResolution(bookmarkPresentation.MinResolution, bookmarkPresentation.MaxResolution)
}
